import { ExternalProviderPlan } from '../../../hooks/api/useExternalProviderPlans';
import { User } from '../../../hooks/api/useUser';
import moment from 'moment';

export interface PartnerResourceConfig {
  needsAddress: boolean;
  processingDate: moment.Moment;
  processingDateString: string;
  waitForProcessingDate: boolean;
}

export interface TeleHealthResourceProps {
  providerPlan: ExternalProviderPlan | null;
  partnerResourceConfig: PartnerResourceConfig;
  ssoLinkUrl?: string;
  ssoLinkUrlPending?: boolean;
}

const getNeedsAddress = (user?: User | null, provider?: string): boolean => {
  if (provider !== 'dialcare') {
    return false;
  }
  return user?.dialcare_status.has_address === false;
};

const getProcessingDate = (user?: User | null, provider?: string): moment.Moment => {
  if (provider === 'revive') {
    return moment(user?.revive_status?.processing_date);
  }
  return moment(user?.dialcare_status.processing_date);
};

// Providers whose access is gated until the member's eligibility record has
// been transferred to the partner (processing_date comes from the API).
const GATED_PROVIDERS = ['dialcare', 'revive'];

const getPartnerResourceConfig = (
  user: User | null,
  providerPlan: ExternalProviderPlan | null,
): PartnerResourceConfig => {
  const provider = providerPlan?.provider;
  const processingDate = getProcessingDate(user, provider);
  return {
    processingDate,
    needsAddress: getNeedsAddress(user, provider),
    processingDateString: processingDate.clone().local().format('MM-DD-YYYY'),
    waitForProcessingDate: !!provider && GATED_PROVIDERS.includes(provider) && processingDate.isAfter(moment()),
  };
};

export default getPartnerResourceConfig;
